import type { FC, ReactNode } from "react"
import React from "react"

import type { ModalProps } from "@chakra-ui/react"
import {
  Modal as CModal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Stack,
} from "@chakra-ui/react"

export interface SuplifulModalProps extends ModalProps {
  title?: string
  actions?: ReactNode
  dataTestId?: string
  showCloseButton?: boolean
}
export const Modal: FC<SuplifulModalProps> = ({
  title,
  children,
  actions,
  dataTestId,
  showCloseButton = true,
  ...rest
}) => {
  return (
    <CModal {...rest}>
      <ModalOverlay />

      <ModalContent
        borderRadius="2xl"
        data-testid={dataTestId ? `${dataTestId}ModalContent` : ""}
      >
        {showCloseButton && (
          <ModalCloseButton
            data-testid={dataTestId ? `${dataTestId}CloseButton` : ""}
          />
        )}

        {title && (
          <ModalHeader
            pb={3}
            data-testid={dataTestId ? `${dataTestId}Title` : ""}
          >
            {title}
          </ModalHeader>
        )}

        <ModalBody data-testid={dataTestId ? `${dataTestId}Body` : ""}>
          {children}

          {actions && (
            <Stack direction="row" mt={8} justify="center">
              {actions}
            </Stack>
          )}
        </ModalBody>
      </ModalContent>
    </CModal>
  )
}
